import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from './types/reducer';

const initialState: IState = {
  list: [],
  detail: null,
  categoryList: [],
  listByCategory: {
    data: null,
    hasMore: false,
    page: 1,
    append: false,
    totalPages: 0,
  },
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getGiftCardDetail.success, (state, { payload }) => {
        state.detail = payload;
      })
      .addCase(actions.getGiftCardToBuy.success, (state, { payload }) => {
        state.list = payload;
      })
      .addCase(actions.getListCategoryGiftCard.success, (state, { payload }) => {
        state.categoryList = payload;
      })
      .addCase(actions.getListGiftCardByCategory.success, (state, { payload }: { payload: IState['listByCategory'] }) => {
        const { data, hasMore, page, append } = payload;

        if (append) {
          state.listByCategory.data = state.listByCategory.data ? [...state.listByCategory.data, ...(data || [])] : data;
        } else {
          state.listByCategory.data = data;
        }

        state.listByCategory.hasMore = hasMore;
        state.listByCategory.page = page;
        state.listByCategory.append = append;
        state.listByCategory.totalPages = payload.totalPages;
      })
      .addCase(actions.resetListGiftCardByCategory, (state) => {
        state.listByCategory = {
          data: null,
          hasMore: false,
          page: 1,
          append: false,
          totalPages: 0,
        };
      });
  },
});

const giftCardServiceReducer = Slice.reducer;
export default giftCardServiceReducer;
